// ============================================================================
// FSA MCA FILING HOOK (ADR-0027)
// ============================================================================

import { useState, useEffect, useCallback } from 'react';
import { fsaMcaFilingService } from 'api/services/fsa/fsaMcaFilingService';
import type { ID } from 'api/types';
import type { McaSheet } from 'api/types/fsa/mcaFiling.types';

export const useFsaMcaFiling = (engagementId: ID | null | undefined, formCode: string) => {
  const [data, setData] = useState<McaSheet | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const refetch = useCallback(async () => {
    if (!engagementId) { setData(null); return; }
    setLoading(true);
    setError(null);
    try {
      const r = await fsaMcaFilingService.getSheet(engagementId, formCode);
      setData(r.data ?? null);
    } catch (err) {
      setError(err as Error);
    } finally {
      setLoading(false);
    }
  }, [engagementId, formCode]);

  useEffect(() => { refetch(); }, [refetch]);
  return { data, setData, loading, error, refetch };
};
